<template>
  <PopupBox :popup-styles="{ top: 10, left: -10 }" placement="bottom-start" @visibility-change="handlePopupVisibilityChange">
    <template v-slot:trigger>
      <a href="#" class="account-balance">
        <BalanceHryvnaIcon class="account-balance__icon mr-2" />
        <div class="account-balance__value">{{ hideBalance ? '_' : formatBalance(balance) }}</div>
        <PopupToggler :is-open="popupVisible" class="ml-2" />
      </a>
    </template>
    <template>
      <AccountBalanceContent
        :balance="balance"
        :credit-limit="creditLimit"
        :hide-balance="hideBalance"
        @toggle-balance-visibility="$emit('toggle-balance-visibility', $event)"
      />
    </template>
  </PopupBox>
</template>

<script>
import { default as AccountBalanceContent } from '../account-balance-popup-content';
import { balanceFormatter } from '@/shared/lib/balance';
import { BalanceHryvnaIcon } from '@/shared/ui/icons';
import { PopupBox, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  props: {
    balance: {
      type: Number,
      default: 0,
    },
    creditLimit: {
      type: Number,
      default: 0,
    },
    hideBalance: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [balanceFormatter, popupToggle],
  components: { BalanceHryvnaIcon, PopupBox, PopupToggler, AccountBalanceContent },
};
</script>

<style lang="scss" scoped>
.account-balance {
  display: flex;
  align-items: center;

  &__value {
    font-family: inherit;
    font-size: 14px;
    font-weight: 500;
    color: #09090B;
  }
}
</style>
